import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faFileArrowDown, faPenToSquare } from "@fortawesome/free-solid-svg-icons";

const TablaSuspensiones = ({ data }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const handleDescargar = (item) => {
    console.log("📥 Descargar:", item.id);
  };

  const handleHistorial = (item) => {
    console.log("📝 Historial de:", item.id_request, item.uuid_employee);
  };

  return (
    <table className="tabla-detalle">
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Motivo</th>
          <th>Días aplicados</th>
          <th>Estado</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, i) => (
          <tr key={i}>
            <td>{formatDate(item.suspension_date || item.fecha || item.date)}</td>
            <td>{item.motivo || item.reason || "-"}</td>
            <td>{item.dias_aplicados || item.applied_days || "-"}</td>
            <td>{item.status || "Pendiente"}</td>
            <td className="contenedor-item">
              <FontAwesomeIcon icon={faPenToSquare} className="icon-edit" title="Editar solicitud" onClick={() => handleHistorial(item)} />
              <FontAwesomeIcon icon={faTrash} className="icon-salida" title="Eliminar solicitud" />
              <FontAwesomeIcon icon={faFileArrowDown} className="icon-File" title="Descargar archivo" onClick={() => handleDescargar(item)} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TablaSuspensiones;
